import { toSafeInteger } from "lodash";
import SelectEventModalView from "../events/tasks/selectEventModal.html";
import InscriptionsTemplatesModalView from "./inscriptionsTemplatesModal.html";

angular.module("inscriptions_forms")

    .controller("InscriptionsFormsListCtrl", ['event', 'is_template', 'LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', '$state', 'modalService', '$uibModal', '$filter', '$translate', 'clipboard', '$location', 'uiGridExporterService', '$stateParams', 'datasetsService',
        function (event, is_template, LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, $state, modalService, $uibModal, $filter, $translate, clipboard, $location, uiGridExporterService, $stateParams, datasetsService) {

        //Comprobamos si tiene permiso escritura       
        $scope.allowWrite = LoginService.permissionExist("INSCRIPTIONS_FORMS_WRITE");
        $rootScope.title = $filter('translate')('inscriptions_forms.title');

        $rootScope.breadcrumb = [
            { title: $filter('translate')('inscriptions_forms.title') }
        ];

        let urlPublic = "";

        Restangular.all("InscriptionsForms").customGET("CustomGetExternalUrl").then(function (url) {
            urlPublic = url;
        });

        //Info evento.
        if (is_template) {
            $scope.is_template = true;
            $rootScope.breadcrumb = [
                { title: $filter('translate')('inscriptions_forms.title') }
            ];
        } else {
            $scope.is_template = false;
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.title'), url: "events.list" },
                { title: event.name, url: "events.edit({ id: " + event.id + " })" },
                { title: $filter('translate')('inscriptions_forms.title') }
            ];

            $rootScope.title = event.name + " - " + $filter('translate')('inscriptions_forms.title');
        }

        $scope.gridOptionsInscriptionsForms = {
            pdfTitle: $filter('translate')('inscriptions_forms.title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                { name: 'event_name', displayName: $filter('translate')('inscriptions_forms.name'), enableFiltering: true, enableHiding: false },
                { name: 'event_description', displayName: $filter('translate')('inscriptions_forms.description'), enableFiltering: true, enableHiding: false },
                //{ name: 'url', displayName: $filter('translate')('inscriptions_forms.url'), enableFiltering: true, enableHiding: false, cellTemplate: "{{row.entity.uid}}"},
                {
                    name: 'event_date_init', visible: (!is_template ? true : false), displayName: $filter('translate')('inscriptions_forms.date_init'), width: 150,
                    type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'',
                    customFormatFn: function (value) {
                        if (value != null) {
                            var fecha = new Date(value);
                            return $filter('date')(fecha, 'dd/MM/yyyy');
                        }
                        return "";
                    },
                    filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                        '<input ui-date="{ dateFormat: \'dd/mm/yy\', firstDay: 1, maxDate: grid.appScope.dateInscriptionsForms.DateTo }" ng-change="grid.appScope.gridOptionsInscriptionsForms.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_init" ng-model="grid.appScope.dateInscriptionsForms.dateInit" required>' +
                        '</div>',
                    enableFiltering: true, enableColumnMenu: false
                },
                {
                    name: 'event_date_end', visible: (!is_template ? true : false), displayName: $filter('translate')('inscriptions_forms.date_end'), width: 150,
                    type: 'date', cellFilter: 'toLocalDate | date:\'dd/MM/yyyy\'',
                    customFormatFn: function (value) {
                        if (value != null) {
                            var fecha = new Date(value);
                            return $filter('date')(fecha, 'dd/MM/yyyy');
                        }
                        return "";
                    },
                    filterHeaderTemplate: '<div class="ui-grid-filter-container">' +
                        '<input ui-date="{ dateFormat: \'dd/mm/yy\', firstDay: 1 }" ng-change="grid.appScope.gridOptionsInscriptionsForms.gridApi.core.raise.itemChanged(grid.appScope);" class="form-control" id="date_end" ng-model="grid.appScope.dateInscriptionsForms.dateEnd" required>' +
                        '</div>',
                    enableFiltering: true, enableColumnMenu: false
                },
                { name: 'active', enableFiltering: true, displayName: $filter('translate')('inscriptions_forms.approval_form'), cellTemplate: "<div class=\"ui-grid-cell-contents\" style=\"text-align: center;\">" +
                    "<span ng-if=\"!row.entity.is_approval_form\" class=\"label label-danger\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                    "<span ng-if=\"row.entity.is_approval_form\" class=\"label label-primary\" style=\"display: inline-block;height: 15px;width: 15px;border-radius: 50%;\"></span>" +
                    "</div>" },
                {
                    name: ' ', visible: (!is_template ? true : false), width: 100, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: "<div class='ui-grid-cell-contents'>" +
                        '<div class="btn-group" uib-dropdown dropdown-append-to-body>' +
                        '<button uib-dropdown-toggle class="btn btn-xs btn-default btn-outline dropdown-toggle">' + $filter('translate')('inscriptions_forms.actions') + '<span class="caret"></span></button>' +
                            '<ul style="overflow: visible;" class="dropdown-menu dropdown-menu-right" role="menu" uib-dropdown-menu>' +
                            '<li> <a ui-sref="events.edit.inscriptions_forms.show_inscriptions({inscription_form_id:row.entity.id})"><i class="fa fa-edit"></i> ' + $filter('translate')('inscriptions_forms.show_inscriptions') + '</a></li>' +
                            '<li> <a ng-click="grid.appScope.export(row.entity.id)"><i class="fas fa-file-excel"> </i> ' + $filter('translate')('inscriptions_forms.export_inscriptions') + '</a></li>' +
                            '<li ng-if="!row.entity.is_approval_form"><a ng-click="grid.appScope.copyToClipboard(row.entity.uid)"> <i class="fa fa-link"></i> ' + $filter('translate')('inscriptions_forms.copy_url') + '</a></li>' +
                            '<li> <a ng-click="grid.appScope.duplicateInEvent(row.entity.id, false)"><i class="fas fa-paste"> </i> ' + $filter('translate')('inscriptions_forms.create_copy_in_event') + '</a></li>' +
                            '<li> <a ng-click="grid.appScope.duplicateInEvent(row.entity.id, true)"><i class="fa fa-copy"> </i> ' + $filter('translate')('inscriptions_forms.duplicate') + '</a></li>' +
                            '<li> <a ng-click="grid.appScope.duplicateAsTemplate(row.entity.id)"><i class="far fa-clone"> </i> ' + $filter('translate')('inscriptions_forms.copy_as_template') + '</a></li>' +
                            '<li> <a ui-sref="events.edit.inscriptions_forms.edit({inscription_form_id:row.entity.id,is_template:row.entity.is_template})"> <i class="fa fa-edit"></i> ' + $filter('translate')('general.button_edit') + '</a></li>' +
                            '<li> <a ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.event_name);" ng-if="grid.appScope.allowWrite"> <i class="fa fa-remove"></i> ' + $filter('translate')('general.button_delete') + '</a></li>' +
                        '</ul>' +
                        '</div>' +
                        '</div>'

                },
                {
                    name: '  ', visible: (is_template?true:false), width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                        { title: $filter('translate')('general.button_edit'), action: 'ui-sref="inscriptions_forms.edit({inscription_form_id:row.entity.id,is_template:row.entity.is_template,event:null})"', cssIconClass: "fa fa-edit" },
                        { title: $filter('translate')('general.button_delete'), action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.event_name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                }
            ],
            getData: function (options) {
                if (is_template) {
                    options.event_id = 0;
                    options.is_template = is_template;
                } else {
                    options.event_id = event.id;
                }
                
                return Restangular.all('InscriptionsForms').getList(options)
            }
        };

        $scope.goToEdit = function (rowEntity) {
            if (is_template) {
                $state.go("inscriptions_forms.edit", { inscription_form_id: rowEntity.id, is_template: is_template });
            } else {
                $state.go("events.edit.inscriptions_forms.edit", { inscription_form_id: rowEntity.id, is_template: is_template  });
            }
            
        };


        $scope.deleteDialog = function (id, event_name) {
            $scope.id = id;
            $scope.event_name = event_name;
            modalService.confirm({
                title: $filter('translate')('inscriptions_forms.button_delete'),
                message: $filter('translate')('inscriptions_forms.delete_message') + " " + $scope.event_name + "?",
                onAccept: function () {
                    Restangular.one('InscriptionsForms', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('inscriptions_forms.delete_success'));
                        $scope.gridOptionsInscriptionsForms.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.copyToClipboard = function (uid) {
            if (!clipboard.supported) {
                alert(urlPublic + "/Inscriptions/Index/" + uid);
            } else {
                clipboard.copyText(urlPublic + "/Inscriptions/Index/" + uid);
            }
        };

        $scope.exportInscriptions = function (id) {
            window.open((window as any).CONFIG.api_url + "/inscriptions/export/csv?inscription_form_id=" + id);
            return;
        };

        $scope.export = function (inscription_form_id) {
            let options = {
                filters: {
                    EXPORT_TYPE: "INSCRIPTION",
                    INSCRIPTION_FORM_ID: inscription_form_id,
                    EVENT_ID: $stateParams.id
                },
                INSCRIPTION_EXPORTATION: true,
            };
            datasetsService.exportByType("inscriptions", options);
        };

        $scope.addFromTemplate = function () {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: InscriptionsTemplatesModalView,
                controller: "InscriptionsTemplatesModalCtrl",
                backdrop: 'static',
                keyboard: false,
                resolve: {
                    event_id: event.id
                }
            });

            $modalInstance.result.then(function (results) {
                $scope.gridOptionsInscriptionsForms.loadData(false);
            });
        }


        $scope.duplicateInEvent = function (id, inSameEvent) {

            if (inSameEvent) {

                Restangular.all('InscriptionsForms').customPOST({}, "DuplicateInscriptionFormToEvent", { id: id, event_id: $stateParams.id }).then(function (result) {
                    if (angular.isDefined(result.id)) {
                        toastr.success($filter('translate')('inscriptions_forms.create_success'));
                        $scope.gridOptionsInscriptionsForms.loadData();
                    } else {
                        $scope.errorMessage = result.message;
                    }
                });

            } else {

                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: SelectEventModalView,
                    controller: "EventSelectModalCtrl",
                    size: 'lg'
                });

                $modalInstance.result.then(function (event) {
                    Restangular.all('InscriptionsForms').customPOST({}, "DuplicateInscriptionFormToEvent", { id: id, event_id: event.event.id }).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('inscriptions_forms.create_success'));
                            $scope.gridOptionsInscriptionsForms.loadData();
                        } else {

                            $scope.errorMessage = result.message;
                        }
                    });
                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });

            }
        }

        // Duplicar como plantilla
        $scope.duplicateAsTemplate = function (rowEntityId) {

            modalService.confirm({
                title: $filter('translate')('inscriptions_forms.copy_as_template'),
                message: $filter('translate')('inscriptions_forms.copy_as_template_message'),
                onAccept: function () { 


                    Restangular.all('InscriptionsForms').customPOST({}, "DuplicateInscriptionFormAsTemplate", { id: rowEntityId }).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('inscriptions_forms.copy_as_template_success'));
                        } else {
                            $scope.errorMessage = result.message;
                            toastr.error($scope.errorMessage);
                        }
                    });
                }
            });   

        }


    }])

    .controller("EventSelectModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'uiSliderConfig', '$uibModal', 
        function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, uiSliderConfig, $uibModal) {

        $scope.selectEvents = [];
        $scope.event = {};

        Restangular.all('Events/AllEvents').getList({}).then(function (results) {
            $scope.selectEvents = results;
        });

        $scope.saveSelectEvent = function () {
            $uibModalInstance.close($scope.event);
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

    }]);


;